

export function isOnvif(code) {
  return code.indexOf('onvif') > -1;
}

export function isHttps() {
  return 'https:' == location.protocol ? true: false;
}

export function formatDate(type,date) { 
	var date = new Date(date);
	var o = {   
		"m+" : date.getMonth()+1,	//月份   
		"d+" : date.getDate(),		//日   
		"h+" : date.getHours(),		//小时   
		"i+" : date.getMinutes(),	//分   
		"s+" : date.getSeconds(),	//秒   
	};   
	if(/(y+)/.test(type)){
		type=type.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length)); 
	};    
	for(var k in o){
		if(new RegExp("("+ k +")").test(type)){
			type=type.replace(RegExp.$1,(RegExp.$1.length==1)?(o[k]):(("00"+ o[k]).substr((""+o[k]).length))); 
		}; 
	}
	return type; 
}

export function downloadBase64Data(data) {
  var a = document.createElement("a"); //Create <a>
  a.href = data; //Image Base64 Goes here
  a.download = "截图.png"; //File name Here
  a.click()
}

// 转换时间格式
export function splitDay(string) {
	if (!string) {
		return ''
	}
	const array = string.split(' ')
	if (array.length > 0) {
		return array[1];
	}
	return '';
}
function getCookie(name) {
	var nameEQ = name + '='
	var ca = document.cookie.split(';')
	for (var i = 0; i < ca.length; i++) {
	var c = ca[i]
	while (c.charAt(0) == ' ') c = c.substring(1, c.length)
	if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
	}
	return null
}
export function loadScript(url, callback) {
	var script = document.createElement("script")
	script.type = "text/javascript";
	script.crossOrigin = true;
	let keyValue = url.replaceAll(/\W/g, '');
	let keyName = `iotProxyHost_${keyValue}`
	if (!getCookie(keyName)) document.cookie = keyName + '=' + url + '; path=' + '/'
	script.src = '/api/iot/oss/proxy/' + keyValue + '/static/imosSdk.min.js'   //指向后端，通过后端请求绕过浏览器跨域
	document.getElementsByTagName("head")[0].appendChild(script);
	script.onload = function () {
		callback();
	};
}
